<template>
  <section class="col-lg-12">
    <div class="modal-body">
      <div class="m-portlet__body">
        <div class="form-group m-form__group row">
          <div :class="[{'has-danger': errors.has(`vehicle_type_id${idx_car}`)}, 'col-lg-6']">
            <label :for="`vehicle_type_id${idx_car}`">{{'vehicle_type' | translate | capitalize }}</label>
            <select :data-vv-as="'vehicle_type' | translate" :name="`vehicle_type_id${idx_car}`" :id="`vehicle_type_id${idx_car}`" v-model="authorization[idx_car].cargo_cars.vehicle_type_id" v-validate="'required'" :class="{'form-control': true, 'error': errors.has(`vehicle_type_id${idx_car}`) }" @change="cargo_vehicles(authorization[idx_car].cargo_cars.vehicle_type_id, idx_car)">
              <option value="">{{ 'select_an_option' | capitalize }}</option>
              <option v-for="(cargo_vehicle, idx) in cargo_vehicle_type" :key="idx" :value="cargo_vehicle.id">
                {{ cargo_vehicle.name | capitalize }}
              </option>
            </select>
            <span v-show="errors.has(`vehicle_type_id${idx_car}`)" class="m-form__help m--font-danger"> {{translateErrorMessage('vehicle_type',errors.first(`vehicle_type_id${idx_car}`))}} </span>
          </div>
          <div v-if="authorization[idx_car].cargo_cars.vehicle_type_id !== ''" :class="[{'has-danger': errors.has(`cargo_type_vehicle_type${idx_car}`)}, 'col-md-6 container-vehicle']">
            <label :for="`cargo_type_vehicle_type${idx_car}`">{{'vehicle_type' | translate | capitalize }}</label>
            <select :data-vv-as="'vehicle_type' | translate" :name="`cargo_type_vehicle_type${idx_car}`" :id="`cargo_type_vehicle_type${idx_car}`" v-model="authorization[idx_car].cargo_cars.cargo_vehicle_type" v-validate="'required'" :class="{'form-control': true, 'error': errors.has(`cargo_type_vehicle_type${idx_car}`) }">
              <option value="">{{ 'select_an_option' | capitalize }}</option>
              <option v-if="hideCargoType(authorization[idx_car].cargo_cars.vehicle_type_id, cargo_vehicle.type)" v-for="(cargo_vehicle, idx) in cargo_type_vehicles" :key="idx" :value="cargo_vehicle.name">
                {{ cargo_vehicle.name | capitalize }}
              </option>
            </select>
            <span v-show="errors.has(`cargo_type_vehicle_type${idx_car}`)" class="m-form__help m--font-danger"> {{translateErrorMessage('vehicle_type',errors.first(`cargo_type_vehicle_type${idx_car}`))}} </span>
          </div>
          <div v-if="authorization[idx_car].cargo_cars.vehicle_type_id !== ''" :class="[{'has-danger': errors.has(`truck_license_plate${idx_car}`)}, 'col-lg-6 container-vehicle']">
            <label :for="`truck_license_plate${idx_car}`">{{'truck_license_plate' | translate | capitalize }}</label>
            <input :data-vv-as="'truck_license_plate' | translate" :name="`truck_license_plate${idx_car}`" :id="`truck_license_plate${idx_car}`" v-validate="'required'" v-model="authorization[idx_car].cargo_cars.truck_license_plate" class="form-control m-input">
            <span v-show="errors.has(`truck_license_plate${idx_car}`)" class="m-form__help m--font-danger"> {{translateErrorMessage('truck_license_plate',errors.first(`truck_license_plate${idx_car}`))}} </span>
          </div>
          <div v-if="authorization[idx_car].cargo_cars.vehicle_type_id !== ''" :class="[{'has-danger': errors.has(`cargo_order${idx_car}`)}, 'col-lg-6 container-vehicle']">
            <label :for="`cargo_order${idx_car}`">{{'cargo_order' | translate | capitalize }}</label>
            <input :data-vv-as="'cargo_order' | translate" :name="`cargo_order${idx_car}`" :id="`cargo_order${idx_car}`" v-model="authorization[idx_car].cargo_cars.cargo_order" v-validate="'required'" class="form-control m-input">
            <span v-show="errors.has(`cargo_order${idx_car}`)" class="m-form__help m--font-danger"> {{translateErrorMessage('cargo_order',errors.first(`cargo_order${idx_car}`))}} </span>
          </div>
          <div v-if="is_articulate" :class="[{'has-danger': errors.has(`trailer_license_plate${idx_car}`)}, 'col-lg-6 container-vehicle']">
            <label :for="`trailer_license_plate${idx_car}`">{{'trailer_license_plate' | translate | capitalize }}</label>
            <input :data-vv-as="'trailer_license_plate' | translate" :name="`trailer_license_plate${idx_car}`" :id="`trailer_license_plate${idx_car}`" v-model="authorization[idx_car].cargo_cars.trailer_license_plate" v-validate="'required'" class="form-control m-input">
            <span v-show="errors.has(`trailer_license_plate${idx_car}`)" class="m-form__help m--font-danger"> {{translateErrorMessage('trailer_license_plate',errors.first(`trailer_license_plate${idx_car}`))}} </span>
          </div>
          <div v-if="authorization[idx_car].cargo_cars.vehicle_type_id !== ''" :class="[{'has-danger': errors.has(`container_number${idx_car}`)}, 'col-lg-6 container-vehicle']">
            <label :for="`container_number${idx_car}`">{{'container_number' | translate | capitalize }}</label>
            <input :data-vv-as="'container_number' | translate" :name="`container_number${idx_car}`" :id="`container_number`" v-model="authorization[idx_car].cargo_cars.container_number" v-validate="'numeric'" class="form-control m-input">
            <span v-show="errors.has(`container_number${idx_car}`)" class="m-form__help m--font-danger"> {{translateErrorMessage('container_number',errors.first(`container_number${idx_car}`))}} </span>
          </div>
          <div v-if="authorization[idx_car].cargo_cars.vehicle_type_id !== ''" :class="[{'has-danger': errors.has(`cargo_vehicle_brand${idx_car}`)}, 'col-lg-6 container-vehicle']">
            <label :for="`cargo_vehicle_brand${idx_car}`">{{'cargo_vehicle_brand' | translate | capitalize }}</label>
            <input :data-vv-as="'cargo_vehicle_brand' | translate" :name="`cargo_vehicle_brand${idx_car}`" :id="`cargo_vehicle_brand${idx_car}`" v-model="authorization[idx_car].cargo_cars.cargo_vehicle_brand" v-validate="'alpha|min:5|max:20'" class="form-control m-input">
            <span v-show="errors.has(`cargo_vehicle_brand${idx_car}`)" class="m-form__help m--font-danger"> {{translateErrorMessage('cargo_vehicle_brand',errors.first(`cargo_vehicle_brand${idx_car}`))}} </span>
          </div>
          <div v-if="authorization[idx_car].cargo_cars.vehicle_type_id !== ''" :class="[{'has-danger': errors.has(`cargo_vehicle_color${idx_car}`)}, 'col-lg-6 container-vehicle']">
            <label :for="`cargo_vehicle_color${idx_car}`">{{'cargo_vehicle_color' | translate | capitalize }}</label>
            <input :data-vv-as="'cargo_vehicle_color' | translate" :name="`cargo_vehicle_color${idx_car}`" :id="`cargo_vehicle_color${idx_car}`" v-model="authorization[idx_car].cargo_cars.cargo_vehicle_color" v-validate="'alpha|min:4|max:20'" class="form-control m-input">
            <span v-show="errors.has(`cargo_vehicle_color${idx_car}`)" class="m-form__help m--font-danger"> {{translateErrorMessage('cargo_vehicle_color',errors.first(`cargo_vehicle_color${idx_car}`))}} </span>
          </div>
          <div v-if="authorization[idx_car].cargo_cars.vehicle_type_id !== ''" :class="[{'has-danger': errors.has(`cargo_vehicle_model${idx_car}`)}, 'col-lg-6 container-vehicle']">
            <label :for="`cargo_vehicle_model${idx_car}`">{{'cargo_vehicle_model' | translate | capitalize }}</label>
            <input :data-vv-as="'cargo_vehicle_model' | translate" :name="`cargo_vehicle_model${idx_car}`" :id="`cargo_vehicle_model${idx_car}`" v-model="authorization[idx_car].cargo_cars.cargo_vehicle_model" v-validate="'min:4|max:20'" class="form-control m-input">
            <span v-show="errors.has(`cargo_vehicle_model${idx_car}`)" class="m-form__help m--font-danger"> {{translateErrorMessage('cargo_vehicle_model',errors.first(`cargo_vehicle_model${idx_car}`))}} </span>
          </div>
          <div v-if="authorization[idx_car].cargo_cars.vehicle_type_id !== ''" :class="[{'has-danger': errors.has(`carrier_company${idx_car}`)}, 'col-lg-6 container-vehicle']">
            <label :for="`carrier_company${idx_car}`">{{'carrier_company' | translate | capitalize }}</label>
            <input :data-vv-as="'carrier_company' | translate" :name="`carrier_company${idx_car}`" :id="`carrier_company${idx_car}`" v-model="authorization[idx_car].cargo_cars.carrier_company" v-validate="'min:5|max:20'" class="form-control m-input">
            <span v-show="errors.has(`carrier_company${idx_car}`)" class="m-form__help m--font-danger"> {{translateErrorMessage('carrier_company',errors.first(`carrier_company${idx_car}`))}} </span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from 'vuex'
// import axios from 'axios'
import { Validator } from 'vee-validate'
import service from '@/services/superaccess'
export default {
  props: [],
  inject: {
    $validator: '$validator'
  },
  data () {
    return {
      authorization: [
        {
          autho: 0,
          identification_number: '',
          first_name: '',
          last_name: '',
          start_date: moment().format('YYYY-MM-DD'),
          end_date: moment().format('YYYY-MM-DD'),
          undefined_date: false,
          authorized_type_id: '',
          identification_type: '',
          observations: '',
          company_origin: '',
          email: '',
          is_responsible: false,
          is_operator: false,
          own_fleet: false,
          profile_operator: '',
          telephone: '',
          location: '',
          position: '',
          visited_to: 0,
          clear_select: false,
          authorization_id: 0,
          access_profile_id: 0,
          access_profile: {},
          access_day: [],
          authorized_credentials: [],
          doc_types: [],
          control_points: [],
          doc_auth_types: [],
          own_cars: [],
          cargo_cars: {
            truck_license_plate: '',
            vehicle_type_id: '',
            cargo_order: '',
            trailer_license_plate: '',
            container_number: '',
            cargo_vehicle_type: '',
            cargo_vehicle_brand: '',
            cargo_vehicle_color: '',
            cargo_vehicle_model: '',
            carrier_company: ''
          },
          config: {
            start: {
              format: 'yyyy-mm-dd',
              minView: 2,
              startDate: moment().format('YYYY-MM-DD'),
              autoclose: true,
              pickerPosition: 'bottom-left'
            },
            end: {
              format: 'yyyy-mm-dd',
              minView: 2,
              startDate: moment().format('YYYY-MM-DD'),
              autoclose: true,
              pickerPosition: 'bottom-left'
            }
          }
        }
      ],
      access_profile_responsible: {},
      access_profile_view: {},
      access_day_view: [],
      access_profile_id: '',
      company_id: '',
      department_id: '',
      authorized_type_id: '',
      is_articulate: false,
      access_profile: {
        income_number: '',
        start_time: '',
        end_time: '',
        control_points: [],
        description: ''
      },
      is_undefined: false,
      create_access_days: false,
      num_authorized: 1,
      hide_ap_container: false,
      companies: [],
      departments: [],
      data_access_day: [],
      access_profiles: [],
      group_register: false,
      hideDepartment: false,
      is_cargo: false,
      group_authorization: 2,
      authorized_types: [],
      identification_types: [],
      profiles: [],
      access_days: [],
      access_credentials: [],
      visited: [],
      cargo_vehicle_type: [],
      group: {
        start_date: moment().format('YYYY-MM-DD'),
        end_date: moment().format('YYYY-MM-DD')
      },
      config: {
        start: {
          format: 'yyyy-mm-dd',
          minView: 2,
          startDate: moment().format('YYYY-MM-DD'),
          autoclose: true,
          pickerPosition: 'bottom-left'
        },
        end: {
          format: 'yyyy-mm-dd',
          minView: 2,
          startDate: moment().format('YYYY-MM-DD'),
          autoclose: true,
          pickerPosition: 'bottom-left'
        }
      },
      config_expiration: {
        format: 'yyyy-mm-dd',
        minView: 2,
        startDate: moment().format('YYYY-MM-DD'),
        autoclose: true,
        pickerPosition: 'bottom-left'
      },
      cargo_type_vehicles: [{ name: 'van', type: 'simple' }, { name: 'wagon', type: 'simple' }, { name: 'camion', type: 'simple' }, { name: 'truck', type: 'articulate' }, { name: 'mini_truck', type: 'articulate' }],
      control_points: [],
      edit: false,
      validateMain: false,
      select2_array: [],
      tab_validator: 0,
      visited_to: '',
      clear_select: false,
      show_expirations: false,
      complete: false,
      hide_cargo: false,
      is_reception: false,
      same_dates: false
    }
  },
  computed: {
    ...mapGetters({ validated: 'getValidated', modal_access_day: 'getModalAccessDay', idx_car: 'getIdxCar', access_day: 'getAccessDay', access_profile_data: 'getAccesProfile', activeUser: 'getUserShard', blockade: 'isBlockade', validate_email: 'getValidateEmail' }),
    hideVisitor () {
      const auth_type = this.authorized_types.find(auth => auth.id === this.authorized_type_id)
      let flag = true
      if (auth_type) {
        if (auth_type.is_visitor === 0) flag = false
      }
      return flag
    },
    title () {
      return this.$options.filters.capitalize('authorization')
    }
  },
  methods: {
    // Valida el objeto que tendra las autorizaciones
    validateAuthorization () {
      let respAuthorizer = true
      let array_email = []
      let mg_error = []
      // Se recorre las autorizaciones para verificar si hay algun campo vacio
      for (let authorizer in this.authorization) {
        if (authorizer === 0) {
          array_email.push({email: this.authorization[authorizer].email})
        }
        // Se verifica si algun correo de la autorizacion ya se encuentra
        if (array_email.find(correo => correo.email === this.authorization[authorizer].email)) {
          mg_error.push({mensaje: 'email_already_exists2'})
        } else {
          array_email.push({email: this.authorization[authorizer].email})
        }
        // Se valida campos de la autorizacion
        if (this.authorization[authorizer].identification_number === undefined || this.authorization[authorizer].first_name.length <= 0 || this.authorization[authorizer].last_name.length <= 0 || this.authorization[authorizer].email.length <= 0) {
          mg_error.push({mensaje: 'complete_fields'})
        }
      }
      // Se visualizan los errores
      if (mg_error.length > 0) {
        respAuthorizer = false
        for (let next in mg_error) {
          this.$toast(mg_error[next].mensaje, 4, 3000, 1000, true)
        }
      }
      return respAuthorizer
    },
    closeForm () {
      if (this.is_main) this.resetForm()
      this.setStatusEditAccessDay(false)
      this.setStatusAccessProfileModal(false)
      this.edit = false
    },
    validateCargoVechicles () {
      this.$validator.validateAll()
        .then((res) => {
          if (res) {
            document.getElementById('close_cargo_vehicle_modal').click()
          }
        })
    },
    validateAccessCredential () {
      const validateAccessCredential = (value, args) => {
        let result = true
        this.authorization[args[0]].authorized_credentials.forEach(element => {
          if (element.credential_id === parseInt(value) && element.idx !== parseInt(args[1])) result = false
        })
        return {
          valid: result,
          data: {
            message: this.$options.filters.capitalize(this.$options.filters.translate('credential_has_been_taken'))
          }
        }
      }
      Validator.extend('validateAccessCredential', {
        validate: validateAccessCredential,
        getMessage: (field, params, data) => {
          return data.message
        }
      })
    },
    hideCargoType (id, type) {
      let cargo_vehicle_type = this.cargo_vehicle_type.find(cvt => cvt.id === id)
      if (cargo_vehicle_type.name === type) return true
      return false
    },
    clearForm (idx) {
      this.authorization[idx].cargo_cars = { truck_license_plate: '', vehicle_type_id: '', cargo_order: '', trailer_license_plate: '', container_number: '', cargo_vehicle_type: 'van', cargo_vehicle_brand: '', cargo_vehicle_color: '', cargo_vehicle_model: '', carrier_company: '' }
    },
    cargo_vehicles (value, idx) {
      const cargo = this.cargo_vehicle_type.find(cargo_vehicle => cargo_vehicle.id === value && cargo_vehicle.name === 'articulate')
      cargo ? this.is_articulate = true : this.is_articulate = false
      this.authorization[idx].cargo_cars.cargo_vehicle_type = ''
    },
    showAccessDayModalChild () {
      this.setStatusAccessProfileModal(true)
      this.setStatusEditAccessDay(false)
      this.setModalAccessDay(false)
      this.setStatusLoadDataAccessDay(true)
      this.access_profile_view = {}
      this.same_dates = this.authorization[this.tab_validator].start_date === this.authorization[this.tab_validator].end_date
      this.access_profile_view = { authorized_type_id: this.authorized_type_id, department_id: this.department_id }
    },
    changeAccesProfile (id) {
      if (id === '-1') this.setStatusRefreshForm(true)
    },
    showAccessProfileModal () {
      if ((this.hideDepartment) || (this.visited_to !== '' && !this.hideDepartment)) {
        this.create_access_days = true
        this.setStatusAccessProfileModal(true)
        this.setStatusEditAccessDay(false)
        this.access_day_view = []
        this.access_profile_view = {}
        this.access_profile_view = { authorized_type_id: this.authorized_type_id, department_id: this.department_id }
      } else {
        this.$toast('fill_responsible', 3)
      }
    },
    infoModal () {
      const access_profile = this.access_profiles.find(ap => ap.id === this.access_profile_id)
      if (access_profile) {
        this.access_profile_view = access_profile
        this.access_day_view = access_profile.access_day
        this.create_access_days = false
        this.setStatusAccessProfileModal(true)
        this.setStatusEditAccessDay(true)
      }
    },
    hideApContainer (department_id) {
      this.access_profile_id = ''
      const idxAuth = this.access_profiles.findIndex(ap => ap.authorized_type_id === this.authorized_type_id)
      const idxDpt = this.access_profiles.findIndex(ap => ap.department_id === this.department_id)
      if (idxAuth !== -1) {
        if (idxDpt !== -1) {
          this.hide_ap_container = true
        } else {
          this.hide_ap_container = false
        }
      } else {
        this.hide_ap_container = false
      }
    },
    clearSelect () {
      this.clear_select = true
      setTimeout(() => {
        this.clear_select = false
      }, 100)
    },
    startDate (value) {
      this.$set(this.config.end, 'startDate', value)
      if (this.group.start_date.replace(':', '') > this.group.end_date.replace(':', '')) {
        this.group.end_date = this.group.start_date
      }
    },
    schemaAuthorization () {
      return { identification_number: '', first_name: '', last_name: '', start_date: moment().format('YYYY-MM-DD'), end_date: moment().format('YYYY-MM-DD'), authorized_type_id: '', identification_type: '', access_profile: {}, access_day: [], undefined_date: false, observations: '', company_origin: '', email: '', is_responsible: false, is_operator: false, own_fleet: false, profile_operator: '', telephone: '', location: '', position: '', visited_to: 0, clear_select: false, authorization_id: 0, authorized_credentials: [], doc_types: [], control_points: [], doc_auth_types: [], own_cars: [], cargo_cars: { truck_license_plate: '', vehicle_type_id: '', cargo_order: '', trailer_license_plate: '', container_number: '' }, config: { start: { format: 'yyyy-mm-dd', minView: 2, startDate: moment().format('YYYY-MM-DD'), autoclose: true, pickerPosition: 'bottom-left' }, end: { format: 'yyyy-mm-dd', minView: 2, startDate: '', autoclose: true, pickerPosition: 'bottom-left' } } }
    },
    pushAuthorization (iterator) {
      iterator = parseInt(iterator)
      if (iterator >= 1 && iterator < 9) {
        this.$spinner.show()
        this.show_expirations = false
        this.authorization = []
        this.tab_validator = 0
        for (let i = 0; i < iterator; i++) {
          this.authorization.push(this.schemaAuthorization())
        }
        this.selectIdentificationType()
        this.retreiveDocAutType(0, this.authorized_type_id)
        this.$spinner.remove()
      } else if (iterator > 10) {
        this.$toast('maximum_authorizations_group', 3)
      } else if (iterator < 1) {
        this.$toast('minimum_authorizations', 3)
      }
    },
    isGrater (idx, evt) {
      const isGrater = (value) => {
        let start = idx !== undefined ? this.authorization[idx].start_time.replace(':', '') : 0
        let end = idx !== undefined ? this.authorization[idx].end_time.replace(':', '') : 1
        return {
          valid: parseInt(end) > parseInt(start),
          data: {
            message: this.$options.filters.capitalize('is_not_grater')
          }
        }
      }
      Validator.extend('isGrater', {
        validate: isGrater,
        getMessage: (field, params, data) => {
          return data.message
        }
      })
    },
    pushDocAuthTypes (idx, doc_auth_types) {
      this.authorization[idx].doc_auth_types = []
      for (let i = 0; i < this.authorization[idx].doc_types.length; i++) {
        this.authorization[idx].doc_auth_types.push({ document_id: '', value: '' })
      }
      this.show_expirations = true
    },
    retreiveDocAutType (idx, val) {
      this.access_profile_id = this.is_reception ? '-1' : ''
      this.show_expirations = false
      const auth = this.authorized_types.find(auth_type => auth_type.id === val && auth_type.is_cargo === 1)
      auth ? this.is_cargo = true : this.is_cargo = false
      if (val > 0) {
        this.$spinner.show()
        this.retrieveData(val)
          .then((res) => {
            if (res.status === 200) {
              this.$spinner.remove()
              this.authorization.forEach((authorization, index) => {
                this.$set(authorization, 'doc_types', res.data.doc_auth_type)
                this.pushDocAuthTypes(index, this.doc_auth_types)
              })
            }
          })
          .catch((err) => {
            this.$spinner.remove()
            console.log(err)
          })
      }
    },
    check_visited () {
      let idx = this.visited.findIndex(v => v.identification_number === this.authorization[0].identification_number)
      if (idx !== -1) {
        this.authorization[0].is_responsible = true
        this.authorization[0].telephone = this.visited[idx].telephone
        this.authorization[0].location = this.visited[idx].location
        this.authorization[0].position = this.visited[idx].position
      }
    },
    pushSelect2Array (data) {
      let newArray = []
      data.forEach((element, key) => {
        if (element.authorization !== null) {
          newArray.push({ id: element.id, text: `${element.first_name} ${element.last_name}`, children: [] })
          newArray[key].children.push({ id: element.id, text: element.identification_number })
        }
      })
      this.select2_array = newArray
    },
    getData () {
      return new Promise((resolve, reject) => {
        this.$spinner.show()
        this.retrieveData()
          .then((res) => {
            if (res.status === 200) {
              resolve(200)
              this.$spinner.remove()
              this.control_points = res.data.control_point
              this.authorized_types = res.data.authorized_type
              this.profiles = res.data.profiles
              this.cargo_vehicle_type = res.data.cargo_vehicle_type
              this.access_credentials = res.data.credentials
              this.identification_types = res.data.document_types
              this.visited = res.data.visited
              this.companies = res.data.companies
              this.departments = res.data.departments
              this.access_profiles = res.data.access_profile.filter(access_profile => access_profile.is_personalized === 0)
              this.days = res.data.days
              this.complete = true
              let activeProfile = this.profiles.find(profile => profile.id === this.activeUser.profile_id)
              if (activeProfile.is_receptionist === 1) {
                this.access_profile_id = '-1'
                this.is_reception = true
              }
              this.selectDefaultAuthType()
              this.pushSelect2Array(this.visited)
              this.selectIdentificationType()
              this.selectAuthorizedType()
              setTimeout(() => {
                window.$('.m_selectpicker').selectpicker('refresh')
              }, 100)
            }
          })
          .catch((err) => {
            this.$spinner.remove()
            this.$toast('error_loading_form', 4)
            console.log(err)
            resolve(400)
          })
      })
    },
    selectDefaultAuthType () {
      if (this.is_cargo_prop) {
        this.authorized_types = this.authorized_types.filter(auth => auth.is_cargo === 1)
        this.authorized_type_id = this.authorized_types[0].id
      } else if (this.is_reception) {
        this.authorized_types = this.authorized_types.filter(auth => auth.is_visitor === 1)
        this.authorized_type_id = this.authorized_types[0].id
      } else {
        this.authorized_types = this.authorized_types.filter(auth => auth.is_cargo === 0)
        const auth_type = this.authorized_types.find(auth => auth.default_authorized === 1)
        if (auth_type) {
          this.authorized_type_id = auth_type.id
          this.hideApContainer()
        }
      }
    },
    selectIdentificationType () {
      let identification = this.identification_types.find(id => id.default_authorized === 1)
      if (identification !== undefined) {
        this.authorization.forEach((auth) => {
          auth.identification_type = identification.id
        })
      }
    },
    selectAuthorizedType (idx = 0) {
      let authorized = this.authorized_types.find(auth => auth.default_authorized === 1)
      if (authorized !== undefined) {
        this.authorization[idx].authorized_type_id = authorized.id
        this.retreiveDocAutType(0, authorized.id)
      } else if (this.is_cargo) {
        this.retreiveDocAutType(0, this.authorized_type_id)
      }
    },
    getDataSelect (value, name) {
      if (value !== '') {
        this.errors.remove(name)
        const visited = this.visited.find(visited => visited.id === parseInt(value))
        this.access_profile_responsible = visited.authorizations[0].access_profile
      }
      this.visited_to = value
    },
    groupRegister (val) {
      this.errors.clear()
      if (val) {
        this.pushAuthorization(this.group_authorization)
      } else {
        this.authorization = []
        this.authorization.push(this.schemaAuthorization())
      }
    },
    create () {
      let data_complete = {}
      let final = this.authorization.length
      if (this.access_profile_id === '-1') {
        this.num_authorized === 1 ? Object.assign(data_complete, this.authorization[this.tab_validator].access_profile, {authorized_type_id: this.authorized_type_id, department_id: this.department_id}) : {}
        if (this.is_reception) Object.assign(data_complete, { company_id: this.company_id })
        this.group_register ? Object.assign(data_complete, this.access_profile_data, {authorized_type_id: this.authorized_type_id, department_id: this.department_id}) : {}
        if (this.num_authorized > 1 && !this.group_register) {
          this.createPersonalizeds()
        } else {
          this.$store.dispatch('saveAccessProfile', {access_profile: data_complete})
            .then((result) => {
              this.authorization.forEach((authorization) => {
                this.$spinner.show()
                if (this.group_register) {
                  Object.assign(authorization, this.group)
                  if (this.is_undefined) {
                    authorization.end_date = ''
                    authorization.undefined_date = this.is_undefined
                  }
                } else {
                  authorization.undefined_date ? authorization.end_date = '' : ''
                }
                authorization.access_profile_id = result.data.access_profile.id
                authorization.visited_to = this.visited_to
                if (this.is_reception) Object.assign(authorization, { company_id: this.company_id })
                this.createAuthorization(authorization)
                  .then((response) => {
                    if (response.data.overlap) {
                      this.$spinner.remove()
                      if (response.data.transfer) {
                        this.confirm_overlap(response.data.transfer_type, response.data.authorization, response.data.data)
                      } else {
                        this.confirm_overlap(response.data.transfer, response.data.authorization, response.data.data)
                      }
                    } else {
                      if (response.data.vehicle_replace) {
                        this.$toast('vehicle_replaced', 2)
                      }
                      this.$toast('authorization_created')
                      final--
                      if (final === 0) {
                        this.$spinner.remove()
                        if (this.is_reception) {
                          this.$router.push({ name: 'reception' })
                        } else if (this.$route.params.create_visited) {
                          this.$router.push({ name: 'visited' })
                        } else if (this.is_cargo_prop === 1) {
                          this.$router.push({ name: 'showStaffCargo' })
                        } else {
                          this.$router.push({ name: 'showStaff' })
                        }
                      }
                    }
                  })
                  .catch((err) => {
                    this.$spinner.remove()
                    final--
                    if (final === 0) this.$router.push({ name: 'showStaff' })
                    this.$toast('error_authorizing_person', 4)
                    console.log(err)
                  })
              })
            })
            .catch((err) => {
              this.$spinner.remove()
              this.$toast('access_profile_error', 4)
              console.log(err)
            })
        }
      } else {
        this.authorization.forEach((authorization) => {
          this.$spinner.show()
          if (this.group_register) {
            Object.assign(authorization, this.group)
            if (this.is_undefined) {
              authorization.end_date = ''
              authorization.undefined_date = this.is_undefined
            }
          } else {
            authorization.undefined_date ? authorization.end_date = '' : ''
          }
          authorization.access_profile_id = this.access_profile_id
          authorization.visited_to = this.visited_to
          this.createAuthorization(authorization)
            .then((res) => {
              if (res.data.overlap) {
                this.$spinner.remove()
                if (res.data.transfer) {
                  this.confirm_overlap(res.data.transfer_type, res.data.authorization, res.data.data)
                } else {
                  this.confirm_overlap(res.data.transfer, res.data.authorization, res.data.data)
                }
              } else {
                this.$toast('authorization_created')
                if (res.data.vehicle_replace) {
                  this.$toast('vehicle_replaced', 2)
                }
                final--
                if (final === 0) {
                  this.$spinner.remove()
                  if (this.$route.params.create_visited) {
                    this.$router.push({ name: 'visited' })
                  } else if (this.is_cargo_prop === 1) {
                    this.$router.push({ name: 'showStaffCargo' })
                  } else {
                    this.$router.push({ name: 'showStaff' })
                  }
                }
              }
            })
            .catch((err) => {
              this.$spinner.remove()
              final--
              this.$toast('error_authorizing_person', 4)
              if (final === 0) this.$router.push({ name: 'showStaff' })
              console.log(err)
            })
        })
      }
    },
    createPersonalizeds () {
      let data_complete = {}
      let final = this.authorization.length
      this.authorization.forEach((authorization) => {
        this.$spinner.show()
        Object.assign(data_complete, authorization.access_profile, {authorized_type_id: this.authorized_type_id, department_id: this.department_id})
        authorization.undefined_date ? authorization.end_date = '' : ''
        this.$store.dispatch('saveAccessProfile', {access_profile: data_complete})
          .then((result) => {
            this.group_register ? Object.assign(authorization, this.group) : ''
            authorization.access_profile_id = result.data.access_profile.id
            authorization.visited_to = this.visited_to
            this.createAuthorization(authorization)
              .then((res) => {
                this.$toast('authorization_created')
                final--
                if (final === 0) {
                  this.$spinner.remove()
                  if (this.is_reception) {
                    this.$router.push({ name: 'reception' })
                  } else if (this.is_cargo_prop === 1) {
                    this.$router.push({ name: 'showStaffCargo' })
                  } else {
                    this.$router.push({ name: 'showStaff' })
                  }
                }
              })
              .catch((err) => {
                this.$spinner.remove()
                final--
                if (final === 0) this.$router.push({ name: 'showStaff' })
                this.$toast('error_authorizing_person', 4)
                console.log(err)
              })
          })
          .catch((err) => {
            this.$spinner.remove()
            final--
            if (final === 0) this.$router.push({ name: 'showStaff' })
            this.$toast('access_profile_error', 4)
            console.log(err)
          })
      })
    },
    validate () {
      if (!this.blockade) {
        this.setClicked(true)
        setTimeout(() => {
          this.$validator.validate().then((res) => {
            if (res) {
              // Valida la/s autorizaciones
              if (this.validateAuthorization()) {
                if (!this.validate_email) {
                  swal({
                    type: 'error',
                    title: this.$options.filters.capitalize('email_already_exists2'),
                    showConfirmButton: false,
                    timer: 3000
                  })
                } else {
                  if (!this.validExpirations()) {
                    if (this.validCars()) {
                      if (!this.group_register && this.access_profile_id === '-1' && Object.keys(this.authorization[this.tab_validator].access_profile).length === 0) {
                        swal({
                          type: 'error',
                          title: this.$options.filters.capitalize('complete_access_data'),
                          showConfirmButton: false,
                          timer: 1500
                        })
                      } else {
                        this.create()
                      }
                    } else {
                      swal({
                        type: 'error',
                        title: this.$options.filters.capitalize('complete_cars'),
                        showConfirmButton: false,
                        timer: 1500
                      })
                    }
                  } else {
                    swal({
                      type: 'error',
                      title: this.$options.filters.capitalize('complete_expirations'),
                      showConfirmButton: false,
                      timer: 1500
                    })
                  }
                }
              }
            } else {
              if (this.validExpirations()) {
                swal({
                  type: 'error',
                  title: this.$options.filters.capitalize('complete_expirations'),
                  showConfirmButton: false,
                  timer: 1500
                })
              }
            }
          })
        }, 0)
      } else {
        swal({
          type: 'warning',
          title: this.$options.filters.capitalize('people_already_blockade'),
          showConfirmButton: false,
          timer: 5000
        })
      }
    },
    uniqueIdentificationNumber (value, key) {
      let result = true
      if (value.length > 6) {
        service.post('/api/person/check-identification-number', this.$store, { identification_number: value, id: this.authorization[key].person_id ? this.authorization[key].person_id : '' })
          .then((response) => {
            if (!response.data.valid && result) {
              result = false
              this.$confirmation()
                .then((res) => {
                  result = true
                  service.post('/api/person/show', this.$store, { identification_number: value })
                    .then((res) => {
                      this.authorization[key].person_id = res.data.id
                      this.authorization[key].first_name = res.data.first_name
                      this.authorization[key].last_name = res.data.last_name
                      this.authorization[key].email = res.data.email
                      this.authorization[key].identification_type = res.data.identification_type
                    })
                    .catch((err) => {
                      console.log(err)
                    })
                })
                .catch((err) => {
                  console.log(err)
                  result = true
                })
            }
          })
      }
    },
    uniqueCredential (value, credential_id, key) {
      if (value.length >= 1) {
        service.post('/api/person/check-credential', this.$store, { value: value, credential_id: credential_id, id: this.authorization[key].person_id ? this.authorization[key].person_id : '' })
          .then((response) => {
            if (!response.data.valid) {
              swal({
                type: 'warning',
                html: this.$options.filters.capitalize('credential_already_assigned'),
                showConfirmButton: false,
                timer: 5000
              })
            }
          })
      }
    },
    ifExistsCredential (id, idx) {
      let final = true
      this.authorization[idx].authorized_credentials.forEach((element) => {
        if (element.credential_id === id) {
          final = false
        }
      })
      return final
    },
    addCar () {
      this.authorization[this.idx_car].own_cars.push({ license_plate: '' })
    },
    dropCar (index) {
      this.authorization[this.idx_car].own_cars.splice(index, 1)
    },
    addCredential () {
      let length = this.authorization[this.idx_car].authorized_credentials.length
      if (length < this.access_credentials.length) {
        this.authorization[this.idx_car].authorized_credentials.push({ credential_id: 0, value: '', idx: length })
      } else {
        this.$toast('maximum_credentials_reached', 3)
      }
    },
    dropCredential (index) {
      this.authorization[this.idx_car].authorized_credentials.splice(index, 1)
    },
    validateForm () {
      return new Promise((resolve, reject) => {
        this.setClicked(true)
        setTimeout(() => {
          this.$validator.validate().then((res) => {
            if (res) {
              if (this.validated) {
                if (!this.validExpirations()) {
                  if (this.validCars()) {
                    if (!this.group_register && this.access_profile_id === '-1' && Object.keys(this.authorization[this.tab_validator].access_profile).length === 0) {
                      resolve(false)
                      swal({
                        type: 'error',
                        title: this.$options.filters.capitalize('complete_access_data'),
                        showConfirmButton: false,
                        timer: 1500
                      })
                    } else {
                      resolve(true)
                    }
                  } else {
                    resolve(false)
                    swal({
                      type: 'error',
                      title: this.$options.filters.capitalize('complete_cars'),
                      showConfirmButton: false,
                      timer: 1500
                    })
                  }
                } else {
                  resolve(false)
                  swal({
                    type: 'error',
                    title: this.$options.filters.capitalize('complete_expirations'),
                    showConfirmButton: false,
                    timer: 1500
                  })
                }
              } else {
                resolve(this.validated)
              }
            } else {
              resolve(false)
            }
          })
            .catch((err) => {
              resolve(false)
              console.log(err)
            })
        }, 200)
      })
    },
    validExpirations () {
      let error = false
      this.authorization[this.tab_validator].doc_auth_types.forEach(elem => {
        error = (elem.value === '' && !this.authorization[this.tab_validator].undefined_date)
      })
      return error
    },
    validCars () {
      let error = true
      this.authorization[this.tab_validator].own_cars.forEach(elem => {
        error = error ? elem.license_plate !== '' : error
      })
      return error
    },
    accessProfile (name) {
      return name.startsWith('personalized-')
    },
    docExpiration (id_doc, key, k, evt) {
      this.errors.remove(`expires_doc_${key}_${k}`)
      this.authorization[key].doc_auth_types[k].document_id = id_doc
    },
    translateErrorMessage (key, errorMessage) {
      let message = ''
      if (errorMessage) {
        message = errorMessage.replace(key, this.$options.filters.capitalize(key))
      }
      return message
    },
    confirm_overlap (transfer, authorization, data) {
      swal({
        title: this.$options.filters.capitalize('attention'),
        html: this.$i18n.tc(transfer ? 'confirm_overlap_message' : 'confirm_overlap_info', 1, {ident_num: data.identification_number, company: data.company, start_date: data.start_date, end_date: data.end_date}),
        type: 'info'
      })
    },
    ...mapActions(['retrieveData', 'createAuthorization', 'showAuthorization', 'editAuthorization', 'setStatusAccessProfileModal', 'setStatusEditAccessDay', 'setModalAccessDay', 'setDataAccessProfile', 'setStatusRefreshForm', 'setStatusLoadDataAccessDay', 'setLoadData', 'createAuthorizationOverlap']),
    ...mapMutations(['setClicked', 'setLoadingData', 'setIdxCar'])
  },
  created () {
    this.setIdxCar(0)
    if (this.$route.params.create_visited) this.authorization[0].is_responsible = true
    if (this.$route.params.document) {
      this.access_profile_id = '-1'
      this.is_reception = true
    }
    this.is_cargo = this.is_cargo_prop === 1
    this.getData()
    this.isGrater()
    this.validateAccessCredential()
  },
  watch: {
    group_register (newVal, oldVal) {
      if (!newVal) {
        this.setDataAccessProfile({})
      }
    },
    tab_validator (newVal) {
      if (newVal === -1) this.tab_validator = 0
    },
    authorized_type_id (newVal, oldVal) {
      const idx = this.authorized_types.findIndex(auth => auth.id === newVal)
      this.department_id = ''
      let flag = true
      if (this.authorized_types[idx].is_visitor === 1) {
        flag = false
        this.access_profile_id = '-1'
      }
      this.hideDepartment = flag
    }
  }
}
</script>
<style scoped>
  .general-data {
    margin-bottom: 0px !important
  }
  .checks {
    border: 0 !important;
  }
  .select_operator {
    padding-top: 20px !important;
  }

  .card-header {
    cursor: pointer;
  }
  .card_title {
    font-weight: bold;
    font-size: 15px;
  }
  .credential_container {
    margin: 15px 0 15px 0 !important;
  }

  div.m-checkbox-inline {
    margin: 10px 0 10px 0 !important;
  }

  label.m-checkbox {
    margin: 15px !important;
  }

  .doc_expiration {
    margin: 3px !important;
  }

  .not-document {
    margin-left: 10px !important;
    font-size: 14px !important;
    font-weight: bold !important;
  }

  #group_register {
    text-align: center !important;
    font-weight: bold !important;
  }

  #how_many_container {
    text-align: center !important;
  }

  #how_many_container > label {
    display: inline-block !important;
  }

  #how_many_container .col-2 {
    display: inline-block !important;
  }

  .container-hide {
    margin-bottom: 20px !important;
  }

  #group-register {
    padding: 10px 10px !important;
  }

  #message-container {
    padding-bottom: 5px !important;
  }

  #content {
    padding-top: 10px !important;
  }

  .select-container {
    text-align: center !important;
  }

  a.clean-select > i {
    color: red !important;
  }
  a.clean-select:hover > i {
    color: white !important;
  }
  .container-register {
    margin-right: 0px !important;
    margin-left: 0px !important;
  }
  .element-register {
    padding-top: 10px !important;
  }
  .checks-align {
    margin-top: 30px !important;
  }
  .actions {
    text-align: right !important;
  }
  .actions > button {
    min-width: 140px;
  }

  .space-row-container {
    padding-bottom: 20px !important;
  }

  .card-container {
    background: #fff;
    border-radius: 2px;
    margin: 1px;
    position: relative;
    box-shadow: 1px 1px 1px 1px #ccc;
    -webkit-transition: box-shadow 0.3s ease-in-out;
    -moz-transition: box-shadow 0.3s ease-in-out;
    -o-transition: box-shadow 0.3s ease-in-out;
    transition: box-shadow 0.3s ease-in-out;
  }
  .card-container:hover {
    box-shadow: 3px 3px 2px 3px #ccc;
  }

  .space-margin-top {
    margin-top: 30px !important;
  }

  .space-down {
    margin-bottom: 20px !important;
  }

  .container-vehicle {
    margin-bottom: 20px !important;
  }
</style>



// WEBPACK FOOTER //
// AddVehicle.vue